import { useAuth } from "../contexts/AuthContext";
import { GlassCard, PageHeader, StatusBadge } from "../components/shared";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ChevronRight, Calendar, ClipboardCheck, FileText, DoorOpen } from "lucide-react";

const QUICK = [
    { to: "/attendance", label: "My attendance", icon: ClipboardCheck, sub: "Punch in & out" },
    { to: "/leaves", label: "My leaves", icon: Calendar, sub: "Apply & track" },
    { to: "/documents", label: "My documents", icon: FileText, sub: "Upload & view" },
    { to: "/exit", label: "Resignation", icon: DoorOpen, sub: "Submit resignation" },
];

export default function SelfService() {
    const { user } = useAuth();
    return (
        <div>
            <PageHeader title="Self Service" subtitle="Quick access to the things you do most." testId="self-service-header" />

            <GlassCard className="p-6 mb-6">
                <div className="flex items-center gap-4">
                    {user?.avatar ? (
                        <img src={user.avatar} alt={user.name} className="w-16 h-16 rounded-2xl object-cover border-2 border-teal-500 shadow-md" />
                    ) : (
                        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-accent grid place-items-center text-white text-2xl font-heading font-bold">{user?.name?.[0]?.toUpperCase()}</div>
                    )}
                    <div className="flex-1">
                        <div className="font-heading text-xl font-bold">{user?.name}</div>
                        <div className="text-sm text-muted-foreground">{user?.designation || "—"} · {user?.department || "—"}</div>
                        <div className="text-xs text-muted-foreground mt-1">ID: <span className="font-mono">{user?.employee_id}</span></div>
                    </div>
                    <StatusBadge status={user?.status} />
                </div>
            </GlassCard>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                {QUICK.map((q) => {
                    const Icon = q.icon;
                    return (
                        <Link key={q.to} to={q.to}>
                            <GlassCard className="p-5 glass-hover h-full flex items-center gap-4" data-testid={`quick-${q.label}`}>
                                <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary grid place-items-center"><Icon className="w-5 h-5" /></div>
                                <div className="flex-1">
                                    <div className="font-medium">{q.label}</div>
                                    <div className="text-xs text-muted-foreground">{q.sub}</div>
                                </div>
                                <ChevronRight className="w-4 h-4 text-muted-foreground" />
                            </GlassCard>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
